import { render, staticRenderFns } from "./Acceso.vue?vue&type=template&id=031d20bf&scoped=true&"
import script from "./Acceso.vue?vue&type=script&lang=js&"
export * from "./Acceso.vue?vue&type=script&lang=js&"
import style0 from "./Acceso.vue?vue&type=style&index=0&id=031d20bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031d20bf",
  null
  
)

export default component.exports